/* G&K Sons theme — storefront interactions (vanilla JS, Shopify AJAX cart) */
(function () {
  'use strict';

  var money = function (cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  };

  /* ---------- toast ---------- */
  var toastEl = document.getElementById('toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.innerHTML = '<span>✓</span>' + msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------- cart count ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
      })
      .catch(function () {});
  }

  /* ---------- mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.menu-toggle');
    if (t) {
      var links = document.querySelector('.nav-links');
      if (links) links.classList.toggle('open');
    }
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    if (val < 1) val = 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- PDP: variant selection ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsData = [];
    try { variantsData = JSON.parse(document.getElementById('variant-data').textContent); } catch (err) {}
    var idInput = productForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var addBtn = productForm.querySelector('[data-add-btn]');

    function selectedOptions() {
      var opts = [];
      productForm.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variantsData.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateVariant() {
      var v = findVariant(selectedOptions());
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    }

    productForm.querySelectorAll('.opt-pill input').forEach(function (input) {
      input.addEventListener('change', function () {
        var group = input.closest('.opt-values');
        if (group) {
          group.querySelectorAll('.opt-pill').forEach(function (p) { p.classList.remove('checked'); });
          input.closest('.opt-pill').classList.add('checked');
        }
        updateVariant();
      });
    });

    /* AJAX add to cart */
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(productForm);
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          toast((item.product_title || 'Item') + ' added to cart');
          refreshCartCount();
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
        })
        .catch(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
          toast('Could not add — please try again');
        });
    });
  }

  /* ---------- card "quick add" buttons ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) { return r.json(); })
      .then(function (item) { toast((item.product_title || 'Item') + ' added to cart'); refreshCartCount(); })
      .catch(function () { toast('Could not add — please try again'); });
  });

  /* ---------- cart line qty change ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var key = input.getAttribute('data-cart-qty');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(input.value, 10) || 0 })
    }).then(function () { window.location.reload(); });
  });

  /* ---------- audience memory (ad LPs → sitewide) ----------
     Ads land with ?utm_audience=home|bulk|designer|commercial. We remember it
     client-side (the page cache rules out server-side variants), stamp it on
     <html> for CSS/JS hooks, and tag GA4 events so every segment funnel is
     measurable. gtag.js from the Google & YouTube app drains this queue. */
  try {
    var aud = new URLSearchParams(location.search).get('utm_audience');
    if (aud) {
      aud = aud.toLowerCase().replace(/[^a-z-]/g, '').slice(0, 24);
      if (aud) localStorage.setItem('gk_audience', aud);
    }
    aud = aud || localStorage.getItem('gk_audience');
    if (aud) {
      document.documentElement.setAttribute('data-audience', aud);
      window.dataLayer = window.dataLayer || [];
      var gtag = function () { window.dataLayer.push(arguments); };
      gtag('event', 'audience_visit', { audience: aud, page_path: location.pathname });
    }
  } catch (e) {}

  /* ---------- event tracking (GA4 via the main-window gtag rail) ----------
     gkTrack stamps every event with the remembered ad audience so lead
     events slice by segment. Sections call window.gkTrack at high-intent
     moments; the delegated listener below catches every wa.me click. */
  function track(name, params) {
    try {
      params = params || {};
      var a = localStorage.getItem('gk_audience');
      if (a) params.audience = a;
      params.page_path = location.pathname;
      if (window.gtag) window.gtag('event', name, params);
    } catch (e) {}
  }
  window.gkTrack = track;
  document.addEventListener('click', function (e) {
    var wa = e.target.closest('a[href*="wa.me"]');
    if (wa) track('whatsapp_click', { link_context: wa.className || 'link' });
  });

  /* ---------- accordion ---------- */
  /* (reveal-on-scroll moved to an inline head script in theme.liquid so
     content never waits on this deferred file to become visible) */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.acc-q');
    if (!q) return;
    var item = q.closest('.acc-item');
    if (item) item.classList.toggle('open');
    var a = item && item.querySelector('.acc-a');
    if (a) a.style.maxHeight = item.classList.contains('open') ? a.scrollHeight + 'px' : 0;
  });

  /* ---------- product card hover video: lazy-load the mp4 on first hover.
     Desktop-only by nature (mouseover) — the touch-scroll autoplay variant
     was reverted 2026-08-07 for causing scroll jank; if it returns it needs
     a one-video-at-a-time cap. ---------- */
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest('.card');
    if (!card) return;
    var v = card.querySelector('video.card-hover-media');
    if (!v) return;
    if (!v.src) v.src = v.getAttribute('data-src');
    v.play().catch(function () {});
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest('.card');
    if (!card || card.contains(e.relatedTarget)) return;
    var v = card.querySelector('video.card-hover-media');
    if (v) v.pause();
  });

  refreshCartCount();
})();
